import React from "react";
import "./Button.css";

const Button = ({
  title,
  color,
  width,
  height,
  background,
  fontSize,
  border,
  fontWeight,
  action,
  icon,
  id,
}) => {
  return (
    <button
      id={id}
      onClick={(e) => {
        action(e);
      }}
      className="btn"
      style={{ color, width, height, background, fontSize, border, fontWeight }}
    >
      {icon}
      {title}
    </button>
  );
};

export default Button;
